export const formatDate = (a: Date | null | undefined) =>
  a === null || a === void 0
    ? ''
    : a.toLocaleString('en-US', { dateStyle: 'medium' });

export const parseDate = (a: string | number | null) =>
  a === null ? null : new Date(a);
